<template>
    <a-modal title="开票资料"
             :width="650"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="onSubmit"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="loading">
        <a-form :form="form" class="form1">
            <a-form-item label="单位名称">
                <a-input
                        disabled
                        style="color: black;"
                        v-decorator="['supplierName',{initialValue:bill.supplierName}]"
                />
            </a-form-item>
            <a-form-item label="纳税人识别号">
                <a-input
                        disabled
                        style="color: black;"
                        v-decorator="['taxpayerCode',{initialValue:bill.taxpayerCode}]"
                />
            </a-form-item>
            <a-form-item label="注册地址">
                <a-input
                        disabled
                        style="color: black;"
                        v-decorator="['registerAddress',{initialValue:bill.registerAddress}]"
                />
            </a-form-item>
            <a-form-item label="电话号码">
                <a-input
                        v-decorator="['tel',{initialValue:bill.tel,rules:[{required:true,message:'电话号码不能为空'}]}]"
                />
            </a-form-item>
            <a-form-item label="开户银行">
                <a-input
                        v-decorator="['bankName',{initialValue:bill.bankName,rules:[{ required: true, message: '开户银行不能为空'}]}]"
                />
            </a-form-item>
            <a-form-item label="银行帐号">
                <a-input
                        v-decorator="['bankAccount',{initialValue:bill.bankAccount,rules: [{ required: true, message: '银行帐号不能为空'}]}]"
                />
            </a-form-item>
            <a-form-item label="账户名称">
                <a-input
                        disabled
                        style="color: black;"
                        v-decorator="['bankAccountName',{initialValue:bill.bankAccountName,rules: [{required:true,message:'账户名称不能为空'}]}]"
                />
            </a-form-item>

            <a-form-item label="银行联行号">
                <a-input
                        v-decorator="['bankCode',{initialValue:bill.bankCode,rules:[{ required: true, message: '银行联行号不能为空'},{type:'string',pattern: /^[0-9]{12}$/,message:'银行联行号格式不正确'}]}]"
                />
            </a-form-item>

            <a-form-item label="银行联行号查询可参考">
                <a href="javascript:;" @click="onThirdSite('http://www.kaihuhang.cn/')"> http://www.kaihuhang.cn/</a>
                <span>&nbsp;&nbsp; 或 &nbsp;&nbsp;</span>
                <a href="javascript:;" @click="onThirdSite('http://www.lianhanghao.com/')"> http://www.lianhanghao.com/</a>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'

    export default {
        created() {
            this.userName = this.$store.getters.nickname
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: this.$form.createForm(this),
                id: this.$route.query.id,
                modalLoading: false,
                loading: false,
                bill: '',
            }
        },
        methods: {
            initInfo() {
                let that = this
                this.$http.get('/api/v1/supplier/billInfo/get.json').then(function (res) {
                    that.bill = res.result
                })
            },
            onSubmit() {
                let params = {...this.form.getFieldsValue()}
                this.form.validateFields((err, values) => {
                    if (err) {
                        return
                    }
                    if (this.bill.id) {
                        params.id = this.bill.id
                    }
                    if (this.bill.supplierType) {
                        params.supplierType = this.bill.supplierType
                    }
                    if (this.bill.supplierId) {
                        params.supplierId = this.bill.supplierId
                    }
                    let that = this;
                    that.loading = true
                    this.$http.post('/api/v1/supplier/billInfo/edit.json',qs.stringify(params)).then(function (response) {
                        that.loading = false
                        if (response.code === 200) {
                            that.$message.success('更新成功')
                            that.$emit('cancel')
                        }
                    })
                });
            },
            onThirdSite(value){
                window.open(value)
            }
        }
    };
</script>
<style lang="less" scoped>
    /deep/ .form1 .ant-form-item{
        display: flex;
    }
    /deep/ .form1 .ant-form-item-label{
        flex-grow: 0;
        flex-shrink: 0;
        width: 154px;
    }
    /deep/ .form1 .ant-form-item-control-wrapper{
        flex: 1 1 100%;
        padding-left: 20px;
    }
</style>
